module.exports = __webpack_public_path__ + "static/396FC6_3_0-60112a4cb7c699c2534fdb2173c92493.woff2";